import { render } from "./CommentSmall.vue?vue&type=template&id=25479949"
import script from "./CommentSmall.vue?vue&type=script&lang=js"
export * from "./CommentSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__